import {useMemo} from 'react'

import type {BuildId} from '../../../types'
import {UserProperties} from '../../../utils/userProperties'
import ContentPanel from '../../common/ContentPanel/ContentPanel'
import {useSequenceLoaderReadyHandler} from '../../common/SequenceLoader/SequenceLoader.hooks'

import {
  useMatrixBuildFilter,
  useMatrixBuildSubsctiption,
  useQueryStateMatrixBuild,
} from './MatrixBuild.hooks'
import MatrixMain from './MatrixMain/MatrixMain'

type Props = {
  className?: string
  seqKey?: string
  buildId: BuildId
}

function MatrixBuild({className, buildId}: Props) {
  const {dependencies, parameters, isReady} = useQueryStateMatrixBuild(buildId)
  const matrixBuildFilter = useMatrixBuildFilter()

  useMatrixBuildSubsctiption(buildId)
  useSequenceLoaderReadyHandler(isReady)

  const renderContent = useMemo(
    () => <MatrixMain {...matrixBuildFilter} buildId={buildId} />,
    [buildId, matrixBuildFilter],
  )

  if (!dependencies?.length || !parameters?.length || !isReady) {
    return null
  }

  return (
    <ContentPanel
      className={className}
      content={renderContent}
      heading={'Matrix Build'}
      panelType={UserProperties.EXPAND_MATRIX_BUILD_SECTION}
      withBorder={false}
    />
  )
}

export default MatrixBuild
